import React from "react";
import ReactMarkdown from "react-markdown";
import AsyncImage from "../../components/AsyncImage";

import styles from "./skupine.module.css";

export default ({ data }) => {
  const {
    image: {
      file: { url },
      description
    },
    vsebina: { vsebina }
  } = data.contentfulPodstran;

  return (
    <div>
      <div className={styles.contentContainer}>
        <div className={styles.mainContentContainer}>
          <div className={styles.imageContainer}>
            <AsyncImage
              imageUrl={url}
              placeholderColor="#ecf0f1"
              alt={description}
            />
          </div>
          <ReactMarkdown className={styles.mainContent} source={vsebina} />
        </div>
        {/* <Povprasevanje /> */}
      </div>
    </div>
  );
};

export const query = graphql`
  query UrnikiQuery {
    contentfulPodstran(naslov: { eq: "Urniki" }) {
      id
      vsebina {
        vsebina
      }
      image {
        file {
          url
        }
        description
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/klub/urniki.js